module.exports = __webpack_public_path__ + "img/centurion-exxperience-banner.9f2e832c.jpg";